module.exports = __webpack_public_path__ + "img/智慧屏场景_广告屏.d05ab392.png";